<script>
import api from "@/api";

export default {
  name: "SpaceIncome",
  data: function () {
    return {
      payments: [],
    };
  },
  methods: {
    getSpaceIncome: function () {
      var SpaceID = this.$route.params.SpaceID;
      const url = "/SpaceIncome/" + SpaceID + "/";
      api.Manager.axios.get(url).then((response) => {
        const data = response.data;
        var a = data;
        if (data.results) {
          a = data.results;
        }
        this.payments = a;
      });
    },
  },
  created: function () {
    this.getSpaceIncome();
  },
};
</script>

<template>
  <div id="SpaceIncome" class="container-fluid">
    <div class="row">
      <template v-if="payments.length">
        <div class="col-12">
          <div class="row">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Group</th>
                  <th>Amount</th>
                  <th>Paid Date</th>
                  <th>Payment Method</th>
                  <th>Booking StartTime</th>
                  <th>Booking EndTime</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="payment in payments" :key="payment.id">
                  <td>{{ payment.schedule.group.name }}</td>
                  <td>{{ payment.amount }}</td>
                  <td>{{ payment.date }}</td>
                  <td>{{ payment.payment_method }}</td>
                  <td>{{ payment.schedule.start_time }}</td>
                  <td>{{ payment.schedule.end_time }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="col-12 text-center">No Payments Yet.</div>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
#SpaceIncome {
  padding-top: 10px;
  .space {
    background: white;
    border: 1px solid #ccc;
    border-radius: 1px;
    margin-bottom: 5px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
